module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fbWnp"))).then(() => module.bundle.root('ewmtE'));